import { Component, computed, inject, input, output, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';

import { MenuItem } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';
import { Avatar } from 'primeng/avatar';
import { Menubar } from 'primeng/menubar';
import { RippleModule } from 'primeng/ripple';

import { UserState } from '@core/state/user-state';
import { AuthService } from '@core/services/auth.service';

export interface MenuItemCustom {
  label: string;
  path?: string;
  position?: 'right';
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  host: { class: 'block z-50', '[class.sticky]': 'isSticky()', '[class.top-0]': 'isSticky()' },
  imports: [RouterLink, RouterLinkActive, NgClass, Avatar, MenuModule, Menubar, RippleModule]
})
export class HeaderComponent {
  @ViewChild('menu') menu!: Menu;

  menuConfig = input<MenuItemCustom[]>([]);
  isSticky = input<boolean>(false);
  toggleSidenav = output<void>();
  changeCreditUnion = output<void>();

  private router = inject(Router);
  private userState = inject(UserState);
  private authService = inject(AuthService);

  userProfileData = this.userState.userProfileData;
  creditUnionName = this.userState.creditUnionName;
  hasMultipleCreditUnions = this.userState.hasMultipleCreditUnions;
  userInitials = computed(() => {
    return (this.userProfileData()?.firstName?.charAt(0) || '') + (this.userProfileData()?.lastName?.charAt(0) || '');
  });

  leftMenuItems = computed(() => this.menuConfig().filter(item => !item.position));
  rightMenuItems = computed(() => this.menuConfig().filter(item => item.position === 'right'));

  accountItems: MenuItem[] = [
    { label: 'Settings', icon: 'settings', id: 'settings', command: () => this.router.navigate(['/settings']) },
    { label: 'Log out', icon: 'logout', id: 'logout', command: () => this.logout() },
  ];

  get isMenuOpen(): boolean {
    return this.menu?.visible || false;
  }

  openChangeCreditUnion(): void {
    this.menu.hide();
    this.changeCreditUnion.emit();
  }

  logout(): void {
    this.authService.logout();
  }
}
